import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=36d30f4c&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=36d30f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d30f4c",
  null
  
)

export default component.exports